import { useContext } from "react";
import { ErrorContext } from "../contexts";

const useError = () => {
  return useContext(ErrorContext);
};

export default useError;
